import {
    getMeterAssignment,
    listMeterAssignments
} from './queries';
import {
    createMeterAssignment,
    deleteMeterAssignment,
    updateMeterAssignment,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {MeterAssignment} from "../types.ts";
import {billingApiClient} from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";
import {buildDeleteMeterAssignmentInput} from "./buildMeterAssignmentInput.ts";

export type ListMeterAssignments = {
    listMeterAssignments: { items: MeterAssignment[], nextToken: string }
}

export type GetMeterAssignment = {
    getMeterAssignment: MeterAssignment
}

export type CreateMeterAssignment = {
    createMeterAssignment: MeterAssignment
}

export type UpdateMeterAssignment = {
    updateMeterAssignment: MeterAssignment
}

export type DeleteMeterAssignment = {
    deleteMeterAssignment: string
}


const client = billingApiClient;

export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListMeterAssignments>>({
                                                                                  query: listMeterAssignments,
                                                                                  variables: {
                                                                                      ...query
                                                                                  },
                                                                              });
    return {
        items: response.data?.listMeterAssignments.items,
        nextToken: response.data?.listMeterAssignments.nextToken
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetMeterAssignment>>({
                                                                                query: getMeterAssignment,
                                                                                variables: {id: id},
                                                                            });
    return response.data?.getMeterAssignment;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateMeterAssignment>>({
                                                                                   query: createMeterAssignment,
                                                                                   variables: {input: payload},
                                                                               });
    console.debug('in the service response', response);
    return response.data?.createMeterAssignment;
};

export const update = async (id: string, record: MeterAssignment) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateMeterAssignment>>({
                                                                                   query: (updateMeterAssignment),
                                                                                   variables: {input: record},
                                                                               });
    return response.data?.updateMeterAssignment;
};

// FNP-217: delete is by composite key { customerId, sortKey }, NOT by id. Pass
// the selected row (which carries both) so the resolver can address the item.
export const deleteRecord = async (record: Pick<MeterAssignment, 'customerId' | 'sortKey'>) => {
    const response = await client.graphql<GraphQLQuery<DeleteMeterAssignment>>({
                                                                                   query: (deleteMeterAssignment),
                                                                                   variables: {input: buildDeleteMeterAssignmentInput(record)},
                                                                               });
    return response.data?.deleteMeterAssignment;
};
